import apiClient from '../client';
import { BASE_ENDPOINTS, RESOURCES } from '../common/constants';

const AUTH_BASE = BASE_ENDPOINTS.createEndpoint(
  null,
  null,
  RESOURCES.AUTHENTICATION,
  false
);

export const authenticationApi = {
  login: () => `${AUTH_BASE}/user/login`,

  refresh: refreshToken => `${AUTH_BASE}/user/refresh`,

  logout: () => `${AUTH_BASE}/user/logout`
};
